import { HTTP_METHOD } from "../../../helper/constants";
import request from "../../request";

const adminApi = {
  fileUploadType: (body) => {
    const url = `/file/fileUploadType/list`;
    return request({
      method: HTTP_METHOD.GET,
      url,
    });
  },
  uploadCSV: (body) => {
    const { file, fileUploadType } = body;
    const url = `/file/fileUploadTypeId/${fileUploadType}/upload`;
    return request({
      method: HTTP_METHOD.POST,
      responseType: "blob",
      url,
      data: body,
      headers: { "Content-Type": "multipart/form-data" },
    });
  },
  reportFilterList: () => {
    const url = `/vertical/list`;
    return request({
      method: HTTP_METHOD.GET,
      url,
    });
  },
  reportFilterList: (reportId) => {
    const url = `/report/${reportId}/filter/list`;
    return request({
      method: HTTP_METHOD.GET,
      url,
    });
  },
  roleCreate: (payload) => {
    const { businessId, name } = payload;
    const url = `/business/${businessId}/role/create`;
    return request({
      method: HTTP_METHOD.POST,
      url,
      data: { name },
    });
  },
  roleList: (businessId) => {
    const url = `/business/${businessId}/role/list`;
    return request({
      method: HTTP_METHOD.GET,
      url,
    });
  },
  userSearch: (searchText) => {
    const url = `/user/search`;
    return request({
      method: HTTP_METHOD.GET,
      url,
      params: { name: searchText },
      silent: true,
    });
  },
  globalRoleList: () => {
    const url = `user/global-roles/list`;
    return request({
      method: HTTP_METHOD.GET,
      url,
    });
  },
  reportList: () => {
    const url = `/report/list`;
    return request({
      method: HTTP_METHOD.GET,
      url,
    });
  },
  entityTypeList: () => {
    const url = `/entity-access/entityType/list`;
    return request({
      method: HTTP_METHOD.GET,
      url,
    });
  },
  filterValueOptions: () => {
    const url = `/filter/list`;
    return request({
      method: HTTP_METHOD.GET,
      url,
    });
  },
  childFilterValueOptions: (filterId) => {
    const url = `/filter/${filterId}`;
    return request({
      method: HTTP_METHOD.GET,
      url,
    });
  },
  businessDelete: (businessId) => {
    const url = `business/${businessId}/delete`;
    return request({
      method: HTTP_METHOD.DELETE,
      url,
    });
  },
  dashboardDelete: (dashboardId) => {
    const url = `dashboard/${dashboardId}/delete`;
    return request({
      method: HTTP_METHOD.DELETE,
      url,
    });
  },
  filterDelete: (filterId) => {
    const url = `filter/${filterId}/delete`;
    return request({
      method: HTTP_METHOD.DELETE,
      url,
    });
  },
  dashboardGroupDelete: (dashboardGroupId) => {
    const url = `dashboard/group/${dashboardGroupId}/delete`;
    return request({
      method: HTTP_METHOD.DELETE,
      url,
    });
  },
  reportDelete: (reportId) => {
    const url = `/report/${reportId}/delete`;
    return request({
      method: HTTP_METHOD.DELETE,
      url,
    });
  },
  businessCreate: (payload) => {
    const url = `/business/create`;
    return request({
      method: HTTP_METHOD.POST,
      url,
      data: payload,
    });
  },
  userUpdate: (payload) => {
    const url = `/user/update`;
    return request({
      method: HTTP_METHOD.PUT,
      url,
      data: payload,
    });
  },
  userCreate: (payload) => {
    const url = `/user/create`;
    return request({
      method: HTTP_METHOD.POST,
      url,
      data: payload,
    });
  },
  accessManage: (payload) => {
    const url = `/entity-access/create`;
    return request({
      method: HTTP_METHOD.POST,
      url,
      data: payload,
    });
  },
  verticalList: (body) => {
    const url = `/vertical/list`;
    return request({
      method: HTTP_METHOD.GET,
      url,
    });
  },
  filterCreate: (payload) => {
    const url = `/filter/create`;
    return request({
      method: HTTP_METHOD.POST,
      url,
      data: payload,
    });
  },
  filterUpdate: (payload) => {
    const url = `/filter/update`;
    return request({
      method: HTTP_METHOD.PUT,
      url,
      data: payload,
    });
  },
  mapFilterToReport: (payload) => {
    const { reportId, filterId } = payload;
    const url = `report/${reportId}/filter/${filterId}/create`;
    return request({
      method: HTTP_METHOD.POST,
      url,
    });
  },
};

export default adminApi;
